import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Wheels brand — derived from the deep red of the WHEELS wordmark
// (wlogo.png ≈ #B5191D). Used for CTAs, active states, links, and any
// moment we want the user to commit to an action. Sidebar stays dark
// navy (globals.css --wheels-sidebar-bg) so the red has room to land.
const wheelsRed: MantineColorsTuple = [
  '#fdf2f2',
  '#fbe6e6',
  '#f5c2c2',
  '#ec9a9a',
  '#df6e6e',
  '#cc4444',
  '#b5191d', // 6 — primary (matches the logo)
  '#9b1417',
  '#810e11',
  '#66070a',
];

export const theme = createTheme({
  fontFamily:
    '"SST Arabic Roman", "Noto Kufi Arabic", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  headings: {
    fontFamily:
      '"SST Arabic Roman", "Noto Kufi Arabic", system-ui, -apple-system, sans-serif',
    fontWeight: '600',
    sizes: {
      h1: { fontSize: '1.875rem', lineHeight: '1.25' },
      h2: { fontSize: '1.5rem', lineHeight: '1.3' },
      h3: { fontSize: '1.25rem', lineHeight: '1.35' },
      h4: { fontSize: '1.125rem', lineHeight: '1.4' },
    },
  },
  colors: { wheels: wheelsRed },
  primaryColor: 'wheels',
  primaryShade: { light: 6, dark: 5 },
  defaultRadius: 'md',
  cursorType: 'pointer',
  components: {
    Button: {
      defaultProps: { size: 'md' },
      styles: { root: { fontWeight: 500 } },
    },
    Card: {
      defaultProps: { withBorder: true, radius: 'md', shadow: 'none' },
      styles: { root: { borderColor: 'var(--wheels-border)' } },
    },
    Paper: {
      defaultProps: { withBorder: true, radius: 'md', shadow: 'none' },
      styles: { root: { borderColor: 'var(--wheels-border)' } },
    },
    TextInput: { defaultProps: { size: 'md' } },
    PasswordInput: { defaultProps: { size: 'md' } },
    Select: { defaultProps: { size: 'md' } },
    NumberInput: { defaultProps: { size: 'md' } },
    Badge: { defaultProps: { radius: 'sm' } },
    Tooltip: { defaultProps: { withArrow: true, openDelay: 300 } },
    Modal: {
      defaultProps: {
        overlayProps: { backgroundOpacity: 0.45, blur: 2 },
        radius: 'md',
      },
    },
    Drawer: {
      defaultProps: {
        overlayProps: { backgroundOpacity: 0.45, blur: 2 },
      },
    },
    Table: {
      defaultProps: { verticalSpacing: 'sm' },
    },
  },
});
